import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { asStyledComponent } from '@cld/component-enhancer';
import { getAssetUrl } from '../../utils';
import { messages } from '../../i18n';

export interface LogoProps {
  blue?: boolean;
}

const LogoBase: FC<LogoProps> = ({ blue = false, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <img
      src={getAssetUrl(blue ? 'cloudinary-logo-blue.svg' : 'cloudinary-logo.svg')}
      alt={formatMessage(messages['loginModal.main.accountCredentials.inputs.cloudName.label'])}
      {...rest}
    />
  );
};

export const Logo = asStyledComponent(LogoBase);
